import React from "react";
import { getFormattedNumber } from "../utils/textUtils";

const CustomerPriceListReport = ({ resPacket }) => {
    return (
        <div>
            {resPacket && resPacket.length > 0 ? (
                <table className="customTable">
                    <thead>
                        <tr>
                            <th className="pl-4">Customer Name</th>
                            <th>Phone Number</th>
                            <th className="pl-4">Email</th>
                            <th className="pl-4">GST Number</th>
                            <th className="pl-4">FSSAI</th>
                            <th className="pl-4">Price List</th>
                            <th className="pl-4">Payment Term</th>
                            <th className="pl-4">Discount</th>
                            <th className="pl-4">Billing Address</th>
                            {/* <th className="pl-4">Billing Street 2</th> */}
                            <th className="pl-4">Shipping Address</th>
                            <th className="pl-4">Zip Code</th>
                            <th className="pl-4">Country</th>
                            <th className="pl-4">Place of Supply</th>
                        </tr>
                    </thead>
                    <tbody>
                        {resPacket.map((row, i) => (
                            <tr key={i}>
                                <td>{row.customerName}</td>
                                <td>{row.phoneNumber}</td>
                                <td>{row.email}</td>
                                <td>{row.gst_number}</td>
                                <td>{row.fssai}</td>
                                <td>{row.priceList}</td>
                                <td>{row.payment_term_title}</td>
                                <td>{row.discount_value}</td>
                                <td>{`${row.billingStreet1} ${row.billingStreet2}`}</td>
                                <td>{`${row.shippingStreet1} ${row.shippingStreet2}`}</td>
                                <td>{row.zipCode}</td>
                                <td>{row.country}</td>
                                <td>{row.placeOfSupply}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            ) : (
                <div className="my-3 text-black text-center">No Records Found</div>
            )}
        </div>
    );
};

export default CustomerPriceListReport;
